import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./layout/AppNavbar";
import AppFooter from "./layout/AppFooter";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Clients from "./pages/Clients";
import OnePost from "./pages/OnePost";
// import AllPosts from "./components/AllPosts.js";
// import OnePost from "./components/OnePost.js";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route exact element={<Home />} path="/" />
          <Route exact element={<Contact />} path="/contact" />
          <Route exact element={<About />} path="/about" />
          <Route exact element={<Clients />} path="/clients" />
          <Route exact element={<OnePost />} path="/post/:slug" />
        </Routes>
        <AppFooter />
      </Router>
    </div>
  );
}
export default App;